import React from "react";
import { Pane } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekPaneSet } from "./RecekPaneSet";
import NavComponent from "./NavComponent";
export var AccessDenied = function (_a) {
    var _b = _a.showNavigation, showNavigation = _b === void 0 ? false : _b;
    var formatMessage = useIntl().formatMessage;
    var errorContent = (React.createElement("div", { style: { padding: "20px", textAlign: "center" } },
        React.createElement("h2", null,
            React.createElement(FormattedMessage, { id: "ui-br-users.error.access.denied" })),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-users.error.access.denied.description" }))));
    if (!showNavigation) {
        return errorContent;
    }
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-users.pane.title.navigation",
            }) },
            React.createElement(NavComponent, null)),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-users.error.access.denied",
            }) }, errorContent)));
};
